import React, { useState } from 'react';
import logoImg from './asset/logowhite.png';
import guaranteedImg from './asset/guaranteed.png';
import leftImg from './asset/1.png';
import rightImg from './asset/2.png';
import siltechlifelogo from './asset/Siltech_Life_logo.png'
// Import step images - replace with your actual image paths
import step1Img from './asset/List.gif';
import step2Img from './asset/Sell.gif';
import step3Img from './asset/Ship.gif';
import step4Img from './asset/Earn.gif';

// Import step videos - replace with your actual video paths
import step1Video from './asset/List.mov';
import step2Video from './asset/Sell.mov';
import step3Video from './asset/Ship.mov';
import step4Video from './asset/Earn.mov';
import './App.css';

export default function App() {
  const [isFAQModalOpen, setFAQModalOpen] = useState(false);
  const [isContactModalOpen, setContactModalOpen] = useState(false);
  const [isGoogleFormModalOpen, setGoogleFormModalOpen] = useState(false);
  const [isVideoModalOpen, setVideoModalOpen] = useState(false);
  const [currentVideoUrl, setCurrentVideoUrl] = useState('');

  const openFAQModal = () => setFAQModalOpen(true);
  const closeFAQModal = () => setFAQModalOpen(false);

  const openContactModal = () => setContactModalOpen(true);
  const closeContactModal = () => setContactModalOpen(false);

  const openGoogleFormModal = () => setGoogleFormModalOpen(true);
  const closeGoogleFormModal = () => setGoogleFormModalOpen(false);

  const openVideoModal = (videoUrl) => {
    setCurrentVideoUrl(videoUrl);
    setVideoModalOpen(true);
  };
  
  const closeVideoModal = () => {
    setVideoModalOpen(false);
    setCurrentVideoUrl('');
  };

  // Step images array - replace with your actual image paths
  const stepImages = [
    step1Img, // List step image
    step2Img, // Sell step image
    step3Img, // Ship step image
    step4Img, // Earn step image
  ];

  // Step videos array - replace with your actual video paths
  const videoUrls = [
    step1Video, // List step video
    step2Video, // Sell step video
    step3Video, // Ship step video
    step4Video, // Earn step video
  ];

  return (
    <>
      {/* Hero: 全屏 */}
      <section className="hero">
        <img src={logoImg} alt="Siltech cables hero" className="hero-image" />
        <div className="hero-content">
          <img src={siltechlifelogo} alt="Siltech life logo" className="siltechlifelogo" />
          <p className="tagline">Buy and sell pre-owned Siltech cables with confidence.</p>
          <button className="btn primary" onClick={() => window.location.href = 'https://marketplace.siltechlife.com'}>Browse Marketplace</button>
          <div className="hero-info">
            <p>Authenticated by Siltech</p>
            <p>Resale powered by Solaire</p>
          </div>
        </div>
      </section>

      {/* 主体内容容器 */}
      <div className="page-wrapper">
        {/* Guaranteed Authenticity */}
        <section className="section">
          <div className="content-block">
            <div className="text">
              <h2>Guaranteed Authenticity</h2>
              <p>
                Our authentication process ensures that every Siltech product on our marketplace is genuine.
                Digital certificates provide a permanent record of authenticity and ownership that stays with the
                product throughout its lifetime.
              </p>
              <p>
                All products are verified by Siltech before being listed on the marketplace, giving you complete
                peace of mind when buying pre-owned Siltech cables.
              </p>
            </div>
            <img
            src={guaranteedImg}
            alt="Guaranteed Authenticity"
            className="guaranteed-image"
            />
          </div>
        </section>

        {/* Ready to Sell? */}
        <section className="section cards">
          <h2>Ready to Sell?</h2>
          <div className="card-container">
            {/* 卡片 1 */}
            <div className="card">
            <img src={leftImg}  alt="NFC-Enabled Products" className="card-image" />
              <h3>NFC-Enabled Products</h3>
              <p className="subtitle">For products with NFC tags:</p>
              <ul>
                <li>Your product already has a digital certificate</li>
                <li>Access the certificate through the Siltech APP</li>
                <li>Select item to resell directly from the APP</li>
              </ul>
              <button className="btn gold center">Open APP</button>
            </div>
            {/* 卡片 2 */}
            <div className="card">
            <img src={rightImg} alt="Non-NFC Products" className="card-image" />
              <h3>Non-NFC Products</h3>
              <p className="subtitle">For products with serial numbers:</p>
              <ul>
                <li>Provide the serial number and 4 images of the product (1 overall, 3 details)</li>
                <li>Wait for Siltech's authentication (up to 2 days)</li>
                <li>Receive a digital authentication certificate</li>
                <li>Select item to resell directly from the certificate</li>
              </ul>
              <button className="btn gold center" onClick={openGoogleFormModal}>
                Submit Info
              </button>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className="section how-it-works">
          <h2>How It Works</h2>
          <div className="steps">
            {[
              {
                title: 'List',
                desc: 'Create your listing by uploading photos, adding seller notes, and setting your price and shipping preferences.',
              },
              {
                title: 'Sell',
                desc: 'Buyers can discover your listing on the marketplace, or you can share the unique link directly with anyone that you are selling to.',
              },
              {
                title: 'Ship',
                desc: "You'll be notified as soon as your item is sold. Please ship it using a reputable courier and provide the tracking number for confirmation.",
              },
              {
                title: 'Earn',
                desc: 'Once the buyer has inspected and verified the item, the payment will be promptly released to your account.',
              },
            ].map((step, i) => (
              <div className="step" key={i}>
                <div className="step-circle">{i + 1}</div>
                <h3>{step.title}</h3>
                <p>{step.desc}</p>
                <div className="step-image-container">
                  <img 
                    src={stepImages[i]} 
                    alt={`${step.title} demo`}
                    className="step-image"
                    onClick={() => openVideoModal(videoUrls[i])}
                    onError={(e) => {
                      // 如果图片加载失败，显示占位符
                      e.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjEyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPlN0ZXAgJyArIChpKzEpICsgJyBJbWFnZTwvdGV4dD48L3N2Zz4=';
                    }}
                  />
                  <div className="play-overlay" onClick={() => openVideoModal(videoUrls[i])}>
                    <span className="play-icon">▶</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="section faq-bar">
          <button className="faq-button"  onClick={openFAQModal}>
            <span>Frequently Asked Questions</span>
            <span className="external-icon">↗</span>
          </button>
        </section>
      </div>

      {/* Video Modal */}
      {isVideoModalOpen && (
        <div className="modal-overlay" onClick={closeVideoModal}>
          <div className="modal-content video-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeVideoModal}>×</button>
            <div className="video-container">
              <video 
                controls 
                autoPlay
                width="100%"
                height="400"
                key={currentVideoUrl} // 添加key以确保视频重新加载
              >
                <source src={currentVideoUrl} type="video/mp4" />
                <source src={currentVideoUrl} type="video/webm" />
                <source src={currentVideoUrl} type="video/ogg" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
      )}

      {/* Google Form Modal */}
      {isGoogleFormModalOpen && (
        <div className="modal-overlay" onClick={closeGoogleFormModal}>
          <div className="modal-content google-form-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeGoogleFormModal}>×</button>
            <h2>Cable Information Submission</h2>
            <div className="google-form-container">
              <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSdorFQhBqm8het_cmoYFyssxLb2WNdF8PjpXAGVG1z4Ffsh_g/viewform?embedded=true"
                width="100%"
                height="500"
                frameBorder="0"
                marginHeight="0"
                marginWidth="0"
                title="Cable Information Submission Form"
              >
                Loading…
              </iframe>
            </div>
          </div>
        </div>
      )}

      {isFAQModalOpen && (
        <div className="modal-overlay" onClick={closeFAQModal}>
          <div className="modal-content faq-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeFAQModal}>×</button>
            <h2>Frequently Asked Questions</h2>
           <div className="modal-body">
            <div className="faq-item">
              <h3>How to list an item for sale</h3>
              <p>
                To list an item for resale, go to the account menu and select "Sell This Item." Sellers must upload recent photos of the item's condition and a note on the item for sale. Refer to the Item Condition section for guidance on describing your item accurately.
                Sellers can choose between setting a fixed price or creating an auction. Once a buyer accepts the price or wins the auction, the transaction becomes binding, and the seller must complete the sale at the agreed price.
                Sellers are responsible for covering shipping costs, so they can set shipping restrictions and should factor shipping expenses into the sale price. There are no additional fees deducted from the seller's earnings.

              </p>
            </div>

            <div className="faq-item">
              <h3>How to grade my item</h3>
              <p>
                New: The item is brand new, unused, and in its original packaging with all tags and accessories included.
                Like New: The item has been opened or used minimally but remains in pristine condition with no visible signs of wear. It may include original packaging and accessories.
                Good: The item is fully functional with moderate signs of use, such as minor scratches or wear, but no significant damage. Accessories may be missing.
                Fair: The item is functional but shows noticeable wear, such as scratches, dents, or fabric wear. It may be missing accessories or original packaging.
              </p>
            </div>

            <div className="faq-item">
              <h3>How does shipping work</h3>
              <p>
                Once a buyer makes a purchase or an auction is successfully completed, the seller must ship the item within 7 days. If no tracking number is provided within this timeframe, the order will be automatically canceled.
                Both the buyer and seller can track the order status and shipment details directly in the wallet. Once the item is delivered (confirmed by the tracking update), the buyer has 3 days to accept the item or contact the seller to resolve any issues. If no action is taken within this period, the order will be considered complete.
              </p>
            </div>

            <div className="faq-item">
              <h3>How to resolve a dispute</h3>
              <p>
                If there is an issue with your order, the buyer has 3 days after delivery to take action.
                    · To start a dispute, select "Dispute" on the order confirmation page, which can be accessed from the "Not Yet Claimed" tab in your account. The seller's email will be provided for direct communication. Escrow will be placed on hold until the issue is resolved.
                    · If a return is needed, the buyer can ship the item back to the seller. Once the seller receives the item, they can select "Cancel the Transaction" to refund the buyer and reverse the sale.
                    · If the buyer decides to proceed with the purchase, they can access the order confirmation page, and select "Accept" to complete the transaction.
                    · If a partial refund is needed or an agreement cannot be reached, contact us at hello@mysolaire.xyz, and we will assist in resolving the dispute.

              </p>
            </div>

            <div className="faq-item">
              <h3>What is buyer protection fee</h3>
              <p>
                The Buyer Protection Fee is paid by the buyer and is automatically added at checkout. It ensures that buyers are protected in case of non-delivery or disputes. The 4% fee is added on top of the sale price.
                The seller is responsible for covering shipping costs and applicable sales taxes.
              </p>
            </div>

            <div className="faq-item">
              <h3>What is brand authentication fee</h3>
              <p>
                Brand authentication fee is a fee paid to the brand for verifying an item's authenticity and facilitating its ownership transfer to the buyer. This fee supports the brand's authentication verification service and ensures continued service and support for the new owner. The fee is added on top of the sale price at checkout and is paid by the buyer.
              </p>
            </div>

            <div className="faq-item">
              <h3>Will my identity be visible in an item's history</h3>
              <p>
                A user's (buyer or seller) wallet picture and nickname will be shown in the item's history. To protect your real identity, you can set up or change your account name and account nickname at any time. This can be updated in Settings → Profile → Edit.
              </p>
            </div>

            <div className="faq-item">
              <h3>Do I have to disclose my purchase price</h3>
              <p>
                No, it's optional. The original MSRP from the brand will be shown on the Digital Product Passport (DPP). Sellers can choose whether to disclose their purchase price to potential buyers or have it listed in the item's transaction history. Sellers may do so when creating the resale listing. Research shows that revealing the previous purchase price can boost resale and help close transactions faster.
              </p>
            </div>

            <div className="faq-item">
              <h3>How does the rating system work</h3>
              <p>
                After a transaction is completed, both the buyer and seller have the opportunity to rate each other. These ratings help build trust and transparency within the community. The average of all received ratings will be displayed on each user's profile for future trading references.
              </p>
            </div>

            <div className="faq-item">
              <h3>Can I cancel my listing</h3>
              <p>
                You can deactivate or cancel your listing any time prior to the item is sold. For auctions, if someone already placed a bid on the auction, you can no longer change the terms of the auction or cancel.
              </p>
            </div>

            <div className="faq-item">
              <h3>How do I get paid</h3>
              <p>
                Seller receives the funds 48 - 72 hours after the buyer confirms the order.  This will initially show as credit in your account which you can then cash out via {" "}
                  <a
                    href="https://www.paypal.com/us/webapps/mpp/merchant-fees?_ga=1.114876546.468251579.1709567902#maxfeecap"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    PayPal
                </a>.
                For Paypal payout, there will be a $0.25USD fee for US transfer and 2% (up to $20USD) for international transfer.

              </p>
            </div>

            <div className="faq-item">
              <h3>How to send the item as a gift</h3>
              <p>
                Owner can gift or transfer anything from the account to anyone. Select the "send as gift" option from the item you want to send, and enter the recipient's email. The recipient will have 7 days to confirm the receipt of the item. Recipient may access the order confirmation page from the "Not Yet Claimed" tab or from the security tag on the physical item.  Once confirmed, Digital Product Passport certifying the item ownership will be transferred to the new owner's account.
              </p>
            </div>
            </div>
          </div>
        </div>
      )}

      {/* Contact Modal */}
      {isContactModalOpen && (
        <div className="modal-overlay" onClick={closeContactModal}>
          <div className="modal-content contact-modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={closeContactModal}>×</button>

            <h2>Cable Information Submission</h2>
            <p>Please email the following information to</p>
            <div className="contact-email">
              <span className="email-address">salesoffice@internationalaudioholding.com</span>
              <button className="copy-btn" onClick={() => {
                navigator.clipboard.writeText('salesoffice@internationalaudioholding.com');
              }}>📋</button>
            </div>

            <ol className="contact-list">
              <li>Your Name</li>
              <li>Serie/Name</li>
              <li>Serial Number</li>
              <li>Cable Length</li>
              <li>Type of Connectors</li>
              <li>
                Minimum 4 cable photos that includes  
                <span className="list-note">(Complete cable view, barrels, packaging & certificate)</span>
              </li>
            </ol>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="footer">
        <div className="footer-top">
          <div className="footer-top-inner page-wrapper">
            <div className="footer-col">
              <a href="https://r2n9q8k4.delivery.rocketcdn.me/wp-content/uploads/2020/11/Terms.pdf" target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
            </div>
            <div className="footer-col">
              <a href="https://www.siltechcables.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
            </div>
            <div className="footer-col contact-col">
              <h4>Contact us</h4>
              <p>Edisonweg 8</p>
              <p>6662 NW, Elst</p>
              <p>The Netherlands</p>
              <p>info@siltechcables.com</p>
              <p>+31 481 374 783</p>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <div className="footer-bottom-inner page-wrapper">
            <p>© 2025 Siltech. All rights reserved</p>
            <div className="social-icons">
              {/* <span className="icon">FB</span>
              <span className="icon">LI</span>
              <span className="icon">IG</span> */}
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}